import { REVALIDATE_IF_STALE } from "appConfiguration";
import type { ReactNode } from "react";
import { SWRConfig } from "swr";

const SWRConfigOptions = {
  revalidateOnFocus: false,
  revalidateIfStale: REVALIDATE_IF_STALE,
  errorRetryCount: 5,
};

export function SWRConfigContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  return <SWRConfig value={SWRConfigOptions}>{children}</SWRConfig>;
}
